// Domain-specific wrapper around the generic Pill primitive.
// Maps the legacy DeviceStatus union to the canonical tone vocabulary.

import type { DeviceStatus } from "../api/types";
import { Pill, type PillTone } from "./ui/Pill";

const STATUS_TONE: Record<DeviceStatus, { tone: PillTone; label: string }> = {
  alive: { tone: "ok", label: "Alive" },
  unreachable: { tone: "crit", label: "Unreachable" },
  "no-creds": { tone: "warn", label: "No creds" },
  error: { tone: "crit", label: "Error" },
  unknown: { tone: "neutral", label: "Unknown" },
};

interface DeviceStatusPillProps {
  status: DeviceStatus;
}

export function DeviceStatusPill({ status }: DeviceStatusPillProps) {
  const tone = STATUS_TONE[status] ?? STATUS_TONE.unknown;
  return <Pill tone={tone.tone}>{tone.label}</Pill>;
}
